import script from "./ItemWithContentStandalone.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemWithContentStandalone.vue?vue&type=script&setup=true&lang=ts"

import "./ItemWithContentStandalone.vue?vue&type=style&index=0&id=b07ae1c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b07ae1c0"]])

export default __exports__